var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"announ"},[_c('div',{staticClass:"title"},[_vm._v("工厂类型占比")]),_c('div',{staticClass:"block"},[_c('div',{ref:"chart",attrs:{"id":"mainD"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }